import {
  ArrowUpRight,
  CalendarCheck,
  LayoutGrid,
  MessageSquareText,
  Phone,
  PhoneIncoming,
  Send,
  Users,
} from "lucide-react";
import { Link } from "./Navigation";
import { CLOSE_LINE } from "@/lib/discovery-call";
import { SITE_IDENTITY } from "@/lib/site-identity";

// The home page's close, built the way fora closes: the heading, one line and
// one button, the number, and a product panel that rises into the bottom of
// the frame and holds. The panel is the record the HVAC sample call on /hvac
// leaves behind, so the last screen shows the same call the page has been
// talking about, written down. It is labelled Illustrative: real markup, not
// a screenshot, and nothing in it quotes a price or promises an arrival.
export function HomeClose({
  title = "Your next missed call is the one we should talk about.",
  line = CLOSE_LINE,
}: {
  title?: string;
  line?: string;
}) {
  return (
    <section
      className="hc g-band g-band--evening"
      id="close"
      data-sc-act="flow"
      aria-labelledby="hc-title"
    >
      <div className="rb-wrap hc-wrap">
        <div className="hc-copy" data-sc-in data-sc-stagger="70">
          <h2 id="hc-title">{title}</h2>
          <p className="g-lede">{line}</p>
          <div className="rb-actions">
            <Link to="/book" className="g-btn">
              Book a demo <ArrowUpRight size={17} />
            </Link>
            <a className="rb-close-number" href={SITE_IDENTITY.phone.tel}>
              <Phone size={15} /> {SITE_IDENTITY.phone.display}
            </a>
          </div>
        </div>
        <div
          className="hc-panel g-panel g-panel--strong g-panel--flush"
          data-sc-in
        >
          <div className="g-panel-head">
            <span className="fo-view-title">
              <LayoutGrid size={15} /> Front office
            </span>
            <span className="g-panel-label">Illustrative</span>
          </div>
          <div className="hc-body">
            <ul className="hc-menu" aria-label="Workspace sections">
              <li className="is-on">
                <PhoneIncoming size={15} /> Calls
              </li>
              <li>
                <CalendarCheck size={15} /> Bookings
              </li>
              <li>
                <Users size={15} /> Contacts
              </li>
              <li>
                <Send size={15} /> Follow-ups
              </li>
            </ul>
            <div className="hc-main">
              <div className="hc-call">
                <span className="hc-call-icon" aria-hidden="true">
                  <PhoneIncoming size={18} />
                </span>
                <span>
                  <strong>Sarah Mitchell</strong>
                  <small>HVAC · answered at 10:42 pm</small>
                </span>
                <span className="fo-thread-event is-done">
                  <CalendarCheck size={13} /> Booked
                </span>
              </div>
              <dl className="fo-record">
                <div>
                  <dt>Reason</dt>
                  <dd>AC out, flagged urgent</dd>
                </div>
                <div>
                  <dt>Address</dt>
                  <dd>1247 Hawthorne Drive</dd>
                </div>
                <div>
                  <dt>Held</dt>
                  <dd>Next emergency slot, on-call schedule</dd>
                </div>
                <div>
                  <dt>Access</dt>
                  <dd>Side yard, gate code in the notes</dd>
                </div>
              </dl>
              <div className="hc-thread">
                <span className="fo-thread-event is-done">
                  <MessageSquareText size={13} /> Confirmation text sent
                </span>
                <span className="fo-thread-event is-done">
                  <Send size={13} /> Summary sent to the on-call tech
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
